import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ListingService } from '@app/core/services/listing.service';

@Injectable()
export class TaskResolver implements Resolve<any> {
  constructor(private listingService: ListingService) {}
  resolve(route: ActivatedRouteSnapshot) {
    const listingId = route.params.listingId;
    this.listingService.setListing(listingId);
    this.listingService.setListingId(listingId);
    this.listingService.setRents(listingId);
  }
}
